import { LinearLoading } from './LinearLoading.styles';

export default LinearLoading;
